import React from "react";
import { AddRackOptions } from "../../constants";
import { DateSelector } from "../selectors/DateSelector";
import { RunSelector } from "../selectors/RunSelector";

interface DNARNAQCProps {
  values: AddRackOptions;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

export const DNARNAQC = ({ values, setFieldValue }: DNARNAQCProps) => {
  return (
    <React.Fragment>
      <RunSelector values={values} setFieldValue={setFieldValue} />
      <DateSelector values={values} setFieldValue={setFieldValue} />
    </React.Fragment>
  );
};
